import React from 'react';
import { Section } from './ui/Section';
import { Layers, Utensils, Zap, ShieldCheck, BookOpen, ShoppingCart, Clock } from 'lucide-react';
export function MethodSection() {
  const method = [{
    icon: Layers,
    title: '3 Proteínas Base',
    desc: 'Cocinadas de forma simple para combinar con todo.'
  }, {
    icon: Utensils,
    title: '3 Vegetales Base',
    desc: 'Lavados y picados, listos para usar sin esfuerzo.'
  }, {
    icon: Zap,
    title: '7 Combinaciones',
    desc: 'Fórmulas rápidas para variar sabores sin cocinar.'
  }, {
    icon: ShieldCheck,
    title: 'Menú de Emergencia',
    desc: 'Tu salvavidas para días imposibles.'
  }];
  const includes = [{
    icon: BookOpen,
    title: "Guía para 'Días Malos'",
    desc: 'Diseña tu alimentación pensando en tu peor día.'
  }, {
    icon: ShoppingCart,
    title: 'Lista de Compras',
    desc: 'Con reglas anti-impulso para el súper.'
  }, {
    icon: Clock,
    title: 'Rutina de 25 min',
    desc: 'Mantén el sistema rodando sin esfuerzo.'
  }];
  return <Section background="teal" data-id="element-158">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-159">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#1F2937]" data-id="element-160">
          El Método 3–3–7
        </h2>
        <p className="text-lg text-[#4B5563]" data-id="element-161">
          Un sistema flexible que reduce decisiones al mínimo. No es "cocinar
          mucho". Es{' '}
          <span className="font-bold text-[#1e3a8a]" data-id="element-162">cocinar lo correcto</span>.
        </p>
      </div>

      {/* Method Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-16" data-id="element-163">
        {method.map((item, i) => <div key={i} className="bg-white p-5 rounded-xl border border-[#E5E7EB]" data-id="element-164">
            <div className="bg-[#1e3a8a] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-165">
              <item.icon className="w-6 h-6 text-white" data-id="element-166" />
            </div>
            <h3 className="text-lg font-bold mb-2 text-[#1F2937]" data-id="element-167">
              {item.title}
            </h3>
            <p className="text-[#4B5563] text-sm" data-id="element-168">{item.desc}</p>
          </div>)}
      </div>

      {/* What's Included */}
      <div className="bg-white/50 backdrop-blur-sm p-8 rounded-2xl border border-[#DBEAFE]" data-id="element-169">
        <h3 className="text-2xl font-bold text-[#1F2937] mb-6 text-center" data-id="element-170">
          Qué incluye el ebook
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-171">
          {includes.map((item, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-172">
              <div className="bg-[#EFF6FF] p-3 rounded-lg mb-3" data-id="element-173">
                <item.icon className="w-6 h-6 text-[#1e3a8a]" data-id="element-174" />
              </div>
              <h4 className="font-bold text-[#1F2937] mb-1 text-sm" data-id="element-175">
                {item.title}
              </h4>
              <p className="text-[#6B7280] text-xs" data-id="element-176">{item.desc}</p>
            </div>)}
        </div>
        <p className="text-center mt-6 text-sm text-[#1e3a8a] font-semibold" data-id="element-177">
          + Plantillas imprimibles y checklists
        </p>
      </div>
    </Section>;
}